<template>
  <div>
    <common-dialog
      ref="dialog"
      width="600px"
      show-save-button
      unit="部门"
      edit-title
      id-key="DpId"
      :data="data"
      :form-rules="rules"
      :save-func="api.save"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      close-on-saved
      @closed="setNum=false"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        基本信息
        <el-row class="row-border">
          <el-col :span="12">
            <el-form-item label="部门编号" prop="DpNo">
              <el-input v-model="data.DpNo" placeholder="请填写部门编号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="部门名称" prop="DpName">
              <el-input v-model="data.DpName" placeholder="请填写部门名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="上级部门" prop="Pid">
              <el-select v-model="data.Pid"  >
                <el-option v-for="item in dpList" :key="item.DpId" :value="item.DpId" :label="item.DpName"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="序号" prop="Sort">
              <el-input-number class="inputNumber" :min="0" v-model="data.Sort"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import parmApi from "@/api/sy/parm";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: {
        DpId: 0,
        DpNo: "",
        DpName: "",
        Pid: 0,
        Sort: 0,
        // PName: "",
      },
      api: require("@/api/basic/dp").default,
      parmApi,
      setNum: false,
      dpList: [],
      rules: {
        DpNo: [{ required: true, message: "部门编码不能为空" }],
        DpName: [{ required: true, message: "部门名称不能为空" }],
      },
    };
  },
  computed: {},
  methods: {
    onCreateOpened(data) {
      this.getOption()
    },
    onEditOpened(data) {
      this.setNum = false
      this.getOption()
    },
    getOption() {
      this.dpList = [{ DpId: 0, DpName: '无' }]
      this.api.list({DpId:0}).then(res => {
        res.Data.forEach(e => {
          if(e.DpId != this.data.DpId) {
            this.dpList.push(e)
          }
        });
      })
    }
  },
};
</script>
<style lang="scss">
</style>